/**
 * https allow-list for URLs that come from the API or browser storage.
 *
 * React 18 does not block javascript: hrefs, and window.location.assign /
 * form.action run whatever they are given, so any URL we did not write
 * ourselves goes through safeHttpsUrl before it becomes a link or a
 * navigation target.
 *
 * @module safeUrl
 */

/**
 * The URL unchanged when it parses as an absolute https: URL, else null.
 * @param {unknown} url
 * @returns {string|null}
 */
export function safeHttpsUrl(url) {
  if (typeof url !== 'string' || !url) return null;
  try {
    return new URL(url).protocol === 'https:' ? url : null;
  } catch (error) {
    return null;
  }
}

export default safeHttpsUrl;
